import React from "react";
import {
  Grid,
} from "@mui/material";
import { InstanceTagDTO } from "./types";

export default function InstanceTagTableRow (entry: InstanceTagDTO, bold = false) {
  const {type, image, tag} = entry;
  return (
    <>
      <Grid item xs={1}/>
      <Grid item xs={3} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {type}
      </Grid>
      <Grid item xs={4} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {image}
      </Grid>
      <Grid item xs={3} sx={{fontWeight: bold ? 'bold' : 'normal'}}>
        {tag}
      </Grid>
      <Grid item xs={1}/>
    </>
  );
}